import CmsProvider from '@components/hooks/CmsProvider'
import type { ReactElement } from 'react'
import { CookiesProvider } from 'react-cookie'
import {
  type LayoutProps,
  PageLayoutAndTracking,
} from './HeaderComponents/PageLayoutAndTracking'

export function GuidePageParamsProvided(props: LayoutProps) {
  return (
    <CookiesProvider>
      <CmsProvider>
        <PageLayoutAndTracking {...props} />
      </CmsProvider>
    </CookiesProvider>
  )
}

export function getGuidePageLayoutWithLayoutProps(props: LayoutProps) {
  return function Component(page: ReactElement) {
    return <GuidePageParamsProvided {...props}>{page}</GuidePageParamsProvided>
  }
}
